import Cookies from 'js-cookie';
import { roleEnums, roleNumericEnums } from '../../constants/Constants';

export const userRoleEnums = {
  CUSTOMER_ADMIN: 'CustomerAdmin',
};

const useAuthHook = () => {
  const userRole = Cookies.get('admin');
  const userEmail = Cookies.get('email');
  const userName = Cookies.get('user');

  const isAdUser = userEmail?.includes('@natsteel.com.sg');

  const isCustomerAdmin = userRoleEnums.CUSTOMER_ADMIN === userRole;

  const isUserHasEditAndDeletePermission = (role) =>
    !(
      [roleEnums.CUSTOMER_MANAGEMENT, roleNumericEnums.CUSTOMER_MANAGEMENT].includes(role) &&
      isCustomerAdmin
    );

  return {
    userName,
    userRole,
    isAdUser,
    isCustomerAdmin,
    isUserHasEditAndDeletePermission,
  };
};

export default useAuthHook;
